/**
 * EPIC-P07: Date formatting utilities
 * Consistent date display across admin platform
 */

import { format, formatDistanceToNow, formatRelative } from 'date-fns'

/**
 * Format a date to a standard format (e.g., "Jan 15, 2024")
 */
export function formatDate(date: Date | string | number): string {
  const dateObj = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date
  return format(dateObj, 'MMM d, yyyy')
}

/**
 * Format a date with time (e.g., "Jan 15, 2024 at 3:45 PM")
 */
export function formatDateTime(date: Date | string | number): string {
  const dateObj = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date
  return format(dateObj, 'MMM d, yyyy \'at\' h:mm a')
}

/**
 * Format a date as relative time (e.g., "2 hours ago", "in 3 days")
 */
export function formatRelativeTime(date: Date | string | number): string {
  const dateObj = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date
  return formatDistanceToNow(dateObj, { addSuffix: true })
}

/**
 * Format a date as relative time with fallback to absolute (e.g., "2 hours ago" or "Jan 15, 2024")
 */
export function formatRelativeTimeOrDate(date: Date | string | number, maxDays: number = 7): string {
  const dateObj = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date
  const now = new Date()
  const diffDays = Math.abs((now.getTime() - dateObj.getTime()) / (1000 * 60 * 60 * 24))
  
  if (diffDays <= maxDays) {
    return formatRelativeTime(dateObj)
  }
  
  return formatDate(dateObj)
}
